import produce from 'immer'
import { assign } from 'lodash'

import { FETCH_USERS } from '../action-types'
import { USERS_INITIAL_STATE } from '../initial-states'

const usersReducer = (state = USERS_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_USERS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_USERS.COMPLETE:
      return produce(state, nextState => {
        const results = action.payload.data.users

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: results,
        })
      })

    case FETCH_USERS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: [],
        }),
      )

    case FETCH_USERS.CLEANUP:
      return { ...USERS_INITIAL_STATE }

    default:
      return state
  }
}

export default usersReducer
